import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {styled} from "@mui/material/styles";
import {IOrderDetail, OrderType} from "../models/IOrderDetail";
import {Localization} from "../../../localization/Localization";
import {EnumHelper} from "../../../libraries/util/EnumHelper";

function createData(
	name: string,
	value: string | null | undefined,
) {
	if (!value)
		value = "";
	return {name, value};
}

const StyledTableCell = styled(TableCell)(({theme}) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white,
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14,
	},
}));

const StyledTableRow = styled(TableRow)(({theme}) => ({
	"&:nth-of-type(odd)": {
		backgroundColor: theme.palette.action.hover,
	},
	// hide last border
	"&:last-child td, &:last-child th": {
		border: 0,
	},
}));

export function OrderInformation(props: { order: IOrderDetail }) {
	// if (!props.order.policyId)
	// 	return (<div></div>);
	const order = props.order;
	const rows = [
		createData("OrderId", order.id),
		createData("OrderStatus", EnumHelper.normalizeHotchocolateEnum(order.status)),
		createData("ComparisonId", order.comparisonId),
		createData("UrmSource", order.urmSource),
		createData("UserId", order.userId),
		createData("CognitoId", order.senderId),
		createData("Process Reference", order.processReference)
	];
	
	if (order.creationDateTime)
		rows.push(createData("CreationDate", Localization.formatDateTime(order.creationDateTime)));
	rows.push(createData("Google Analytics Id", order.googleAnalyticsId));
	rows.push(createData("Google Analytics Session Id", order.googleAnalyticsSessionId));
	rows.push(createData("Facebook Fbc", order.metaFbc));
	rows.push(createData("Facebook Fbp", order.metaFbp));
	rows.push(createData("Ip Address", order.ipAddress));
	
	
	if (order.orderType === OrderType.Affiliate)
		rows.push(createData("WebhookProvider", order.webhookProvider));
	
	return (
		<TableContainer component={Paper}>
			<Table sx={{minWidth: 650}} size="small" aria-label="Data">
				<TableBody>
					{rows.map((row) => (
						<StyledTableRow
							key={row.name}
						>
							<StyledTableCell component="th" scope="row">
								{row.name}
							</StyledTableCell>
							<StyledTableCell align="right">{row.value}</StyledTableCell>
						</StyledTableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
	
}
